// Trạng thái rỗng có hướng dẫn (thay cho "No data" trơn).
import { Empty } from "antd";

export default function XuEmptyHint({ title, hint, compact }) {
    return (
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            imageStyle={compact ? { height: 40 } : undefined}
            description={
                <div>
                    <div className="font-medium">{title}</div>
                    {hint && <div className="text-xs text-gray-500 mt-1">{hint}</div>}
                </div>
            }
        />
    );
}
